import(/* webpackMode: "eager" */ "/home/runner/work/lmbr-ameno/lmbr-ameno/src/app/global-error.tsx");
